import { fromEvent as observableFromEvent } from "rxjs";

import type { IAugmentedJQuery, IDirective, IScope, IWindowService } from "angular";
import { module } from "angular";
import { first } from "lodash";
import { debounceTime } from "rxjs/operators";

import $ from "jquery";

export default class MobileTabsDirective implements IDirective {
    private static getActiveTab(tabsContainer: IAugmentedJQuery): IAugmentedJQuery {
        const activeListItem = tabsContainer.find("li.active");
        return activeListItem.length ? activeListItem : tabsContainer.find("li").first();
    }

    private static getTabsTotalWidth(tabsContainer: IAugmentedJQuery): number {
        const liItems = tabsContainer.find("li");

        return [].reduce.call(liItems, (acc: number, liItem: HTMLElement) => acc + liItem.offsetWidth, 0);
    }

    public restrict: "A";

    public priority: 2000;

    constructor(private readonly $window: IWindowService) {}

    public link(scope: IScope, elem: IAugmentedJQuery) {
        const tabsContainer: IAugmentedJQuery = elem.children("ul.nav");
        let inkBar: IAugmentedJQuery = elem.find(".ink-bar");

        tabsContainer.wrap('<div style="overflow: hidden"></div>');

        const changeOffset = (tab: IAugmentedJQuery) => {
            const tabsTotalWidth = MobileTabsDirective.getTabsTotalWidth(tabsContainer);

            if (!inkBar.length) {
                inkBar = $("<div class='ink-bar'></div>");
                tabsContainer.append(inkBar);
            }

            const translateToCenterVal = -tab.position().left - tab.width() / 2 + elem.width() / 2;
            const translateToRightVal = elem.width() - tabsTotalWidth;
            const translateVal =
                translateToCenterVal < translateToRightVal ? translateToRightVal : translateToCenterVal;
            tabsContainer.css({
                transform: `translateX(${translateVal < 0 ? translateVal : 0}px)`,
            });

            inkBar.css({
                left: `${tab.position().left}px`,
                width: `${tab.width()}px`,
            });
        };

        const handleLinkActivation = (mutations: MutationRecord[]) => {
            if (mutations.length) {
                changeOffset(MobileTabsDirective.getActiveTab(tabsContainer));
            }
        };
        const activeTabObserver = new MutationObserver(handleLinkActivation);

        const updateTabsOnLoad = (mutations: MutationRecord[]) => {
            if (mutations.length) {
                mutations.forEach((item: MutationRecord) => {
                    const addedNode = first(item.addedNodes);
                    if ($(addedNode).is("li")) {
                        activeTabObserver.observe(addedNode, {
                            attributes: true,
                            attributeFilter: ["class"],
                        });
                    }
                });
                changeOffset(MobileTabsDirective.getActiveTab(tabsContainer));
            }
        };

        const listItemsObserver = new MutationObserver(updateTabsOnLoad);
        listItemsObserver.observe(tabsContainer[0], { childList: true });

        const resizeObservable = observableFromEvent(this.$window, "resize").pipe(debounceTime(300));
        const resizeSubscription = resizeObservable.subscribe(() => {
            changeOffset(MobileTabsDirective.getActiveTab(tabsContainer));
        });

        scope.$on("$destroy", () => {
            resizeSubscription.unsubscribe();
        });
    }
}

module("mmGui").directive("irMobileTabs", ["$window", ($window) => new MobileTabsDirective($window)]);
